(() => {
  const { gsap, ScrollTrigger, Lenis } = window;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion = !reduceMotion && !!gsap;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  /* Smooth momentum scrolling */
  let lenis = null;
  if (motion && Lenis) {
    lenis = new Lenis({ lerp: 0.085 });
    if (ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      lenis.on('scroll', ScrollTrigger.update);
    }
    gsap.ticker.add((t) => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }
  $$('a[href^="#"]').forEach((a) => a.addEventListener('click', (e) => {
    const t = $(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    if (lenis) lenis.scrollTo(t, { duration: 1.6, easing: (x) => 1 - Math.pow(1 - x, 4) });
    else t.scrollIntoView();
    const n = $('#r-name');
    if (n) setTimeout(() => n.focus({ preventScroll: true }), lenis ? 1500 : 0);
  }));

  /* Countdown to the first door, 1 December */
  const countdown = $('[data-countdown]');
  const now = new Date();
  const first = new Date(now.getFullYear(), 11, 1);
  const days = Math.ceil((first - now) / 86400000);
  if (days > 0) countdown.textContent = `${days} ${days === 1 ? 'day' : 'days'}`;
  else countdown.parentElement.textContent = `Door ${Math.min(24, now.getDate())} opens today`;

  /* Nav turns solid once the pictures are behind you */
  const nav = $('[data-nav]');
  const hero = $('.rsv-hero');
  if (!hero) return;
  const setNav = () => nav.classList.toggle('is-solid', window.scrollY > hero.offsetHeight - 80);
  window.addEventListener('scroll', setNav, { passive: true });
  setNav();

  /* A slow sequence of pictures */
  const frames = $$('[data-frames] img');
  const caption = $('[data-caption]');
  let current = 0;

  const drift = (img) => {
    if (!motion) return;
    gsap.fromTo(img, { scale: 1.08 }, { scale: 1, duration: 9, ease: 'none', overwrite: 'auto' });
  };

  const show = (i) => {
    const from = frames[current];
    const to = frames[i];
    current = i;
    to.classList.add('is-active');
    to.style.zIndex = 1;
    from.style.zIndex = 0;
    drift(to);
    gsap.fromTo(to, { opacity: 0, clipPath: 'inset(0% 0% 0% 100%)' }, {
      opacity: 1, clipPath: 'inset(0% 0% 0% 0%)', duration: 2, ease: 'expo.inOut',
      onComplete: () => { from.classList.remove('is-active'); gsap.set(from, { opacity: 0 }); },
    });
    gsap.to(caption, {
      opacity: 0, y: -6, duration: 0.35, ease: 'power2.in',
      onComplete: () => {
        caption.textContent = to.dataset.caption;
        gsap.fromTo(caption, { opacity: 0, y: 6 }, { opacity: 1, y: 0, duration: 0.8, ease: 'expo.out' });
      },
    });
  };

  let heroVisible = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { heroVisible = e.isIntersecting; }).observe(hero);
  }

  /* Twenty-four doors open, in calendar order, onto the first picture */
  const DAY_FOR_CELL = [17, 3, 22, 9, 14, 6, 11, 24, 1, 19, 8, 15, 5, 13, 20, 2, 23, 10, 21, 7, 12, 16, 4, 18];
  const doors = $('[data-doors]');
  if (!motion) {
    doors.remove();
  } else {
    DAY_FOR_CELL.forEach((d) => {
      const s = document.createElement('span');
      s.textContent = d;
      s.dataset.day = d;
      doors.appendChild(s);
    });
    gsap.set('.rsv-hero__title .line > span', { yPercent: 110 });
    gsap.set(['.rsv-hero__lede', '.rsv-hero__link', '.rsv-hero__meta', '.rsv-hero__scrim', nav], { opacity: 0 });

    const tl = gsap.timeline({ delay: 0.4, onComplete: () => doors.remove() });
    $$('span', doors).forEach((el) => {
      tl.to(el, { scaleX: 0, duration: 0.95, ease: 'power3.inOut' }, (+el.dataset.day - 1) * 0.085);
    });
    tl.add(() => drift(frames[0]), 0.3)
      .to('.rsv-hero__scrim', { opacity: 1, duration: 1.6, ease: 'power2.out' }, 1.6)
      .to('.rsv-hero__title .line > span', { yPercent: 0, duration: 1.5, stagger: 0.1, ease: 'expo.out' }, 1.9)
      .to(['.rsv-hero__lede', '.rsv-hero__link', '.rsv-hero__meta', nav], { opacity: 1, duration: 1.2, stagger: 0.08, ease: 'power2.out' }, 2.3);

    setInterval(() => {
      if (!heroVisible || document.hidden) return;
      show((current + 1) % frames.length);
    }, 6500);

    if (ScrollTrigger) {
      gsap.to('.rsv-hero__copy', {
        yPercent: -18, opacity: 0, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom 30%', scrub: true },
      });
      gsap.to('[data-frames]', {
        yPercent: 12, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true },
      });
      $$('[data-reveal]').forEach((el) => {
        gsap.fromTo(el, { clipPath: 'inset(100% 0% 0% 0%)' }, {
          clipPath: 'inset(0% 0% 0% 0%)', duration: 1.6, ease: 'expo.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        });
        gsap.fromTo($('img', el), { scale: 1.15 }, {
          scale: 1, ease: 'none',
          scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true },
        });
      });
    }
  }

  /* Reservation: validate here, then let Shopify's contact form submit */
  const done = $('[data-rsv-done]');
  if (done) {
    // Shopify reloads the page after a successful post; bring the confirmation into view.
    window.addEventListener('load', () => {
      const t = $('#reserve');
      if (lenis) lenis.scrollTo(t, { immediate: true }); else t.scrollIntoView();
      done.focus({ preventScroll: true });
    });
  }
  const form = $('#ReserveForm');
  const name = $('#r-name');
  const email = $('#r-email');
  if (form && name && email) {
    form.noValidate = true;
    const button = $('button[type="submit"]', form);
    const check = (input, ok) => {
      input.closest('.field').classList.toggle('is-invalid', !ok);
      input.setAttribute('aria-invalid', String(!ok));
      return ok;
    };
    const validName = () => check(name, name.value.trim().length > 1);
    const validEmail = () => check(email, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim()));
    name.addEventListener('blur', () => name.value && validName());
    email.addEventListener('blur', () => email.value && validEmail());
    form.addEventListener('submit', (e) => {
      const ok = [validName(), validEmail()];
      if (ok.includes(false)) {
        e.preventDefault();
        (ok[0] ? email : name).focus();
        return;
      }
      button.setAttribute('aria-busy', 'true');
      button.querySelector('span').textContent = 'Reserving…';
    });
  }
})();
